import NavBar from "./navbar";
function Contact(){
    return(
        <div>
            <NavBar />
            "contact me"
        </div>
    )
}
export default Contact;